import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../stores/useStores';
import type { FreeSpinWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { MiniGameWidgetTimer } from './MiniGameWidgetTimer/MiniGameWidgetTimer';

interface MiniGameWidgetProps {
  sizeType: WidgetSizeType;
  data: FreeSpinWidgetDataType;
}

export function MiniGameWidget(props: MiniGameWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;
  const { userFreeSpinsStore } = useStores();
  const { t } = useTranslation();

  const timerValue = userFreeSpinsStore.getFreeSpinTimerFormatted(event.id, t);
  const hideWidgetTimer = !timerValue;
  const timer = hideWidgetTimer ? null : <MiniGameWidgetTimer eventId={event.id} extended={sizeType === 'wide'} />;
  const smallWidgetExtended = !!timer;
  const widgetImageUrl = event.widgetImage;
  const onClick = () => userFreeSpinsStore.openFreeSpinDialogById(event.id);

  return (
    <WidgetWrapper sizeType={sizeType} smallWidgetExtended={smallWidgetExtended} onClick={onClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}
